import React from "react";
import { FaPaintBrush } from "react-icons/fa";
import { FaLaptopCode } from "react-icons/fa";
import { FaUser } from "react-icons/fa";

const ServicePage = () => {
  return <>
  
  <div class="services" id="services">
        <div class="services-heading">
            <h1>My Services</h1>
            <h4>What i provide</h4>
        </div>
        <div class="services-cards">
            <div class="services-card-1">
                <p className="icon"> <FaPaintBrush/> </p>
                <h1>Web Designer</h1>
                <p>I'm a web designer focusing on crafting user-friendly and creative websites. I'm very much passionate
                    about applying human psychology for an interaction-based approach that leaves a positive impact on
                    the
                    people after visiting the web page. I perfectly balance user and business needs to create delightful products.
                    </p>
            </div>
            <div class="services-card-1">
                <p className="icon"><FaLaptopCode/> </p>
                <h1>Web Developer</h1>
                <p>As a web developer, my power happens to be at behind the scenes to make a responsive website look great, work
                    fast,responsive and
                    perform well with a seamless user experience is my main moto. I enjoy building websites from small
                    business sites to
                    rich interactive and creative web pages from the scratch.</p>
            </div>
            <div class="services-card-1">
                <p className="icon"> <FaUser/> </p>
                <h1>Freelancer</h1>
                <p>
                    If you need someone to make completely new websites, or just to edit or add something, I'm here for
                    you. I go
                    beyond to produce sites with a unique, contemporary look and feel. With extensive
                    knowledge of web mechanics, I'm able to optimize complex integrations to much easier maintenance
                    over the years.</p>
            </div>
        </div>
    </div></>;
};
export default ServicePage;
